import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, XCircle, Loader2, Mail } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage('Token de vérification manquant');
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/verify-email/${token}`);
      setStatus('success');
      setMessage(response.data.message || 'Email vérifié avec succès !');
      toast.success('Email vérifié !');
      setTimeout(() => navigate('/profile'), 3000);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Erreur de vérification');
      toast.error('Erreur de vérification');
    }
  };

  return (
    <Layout>
      <div className="container-app py-16 max-w-md mx-auto">
        <Card className="rounded-2xl text-center">
          <CardContent className="p-8 space-y-6">
            {status === 'loading' && (
              <>
                <div className="flex justify-center">
                  <Loader2 className="w-16 h-16 text-primary animate-spin" />
                </div>
                <h1 className="text-2xl font-bold">Vérification en cours...</h1>
                <p className="text-muted-foreground">Veuillez patienter</p>
              </>
            )}

            {status === 'success' && (
              <>
                <div className="flex justify-center">
                  <div className="p-4 bg-green-100 dark:bg-green-900/30 rounded-full">
                    <CheckCircle className="w-16 h-16 text-green-600 dark:text-green-400" />
                  </div>
                </div>
                <h1 className="text-2xl font-bold text-green-600 dark:text-green-400">Email vérifié !</h1>
                <p className="text-muted-foreground">{message}</p>
                <p className="text-sm text-muted-foreground">Redirection vers votre profil...</p>
              </>
            )}

            {status === 'error' && (
              <>
                <div className="flex justify-center">
                  <div className="p-4 bg-red-100 dark:bg-red-900/30 rounded-full">
                    <XCircle className="w-16 h-16 text-red-600 dark:text-red-400" />
                  </div>
                </div>
                <h1 className="text-2xl font-bold text-red-600 dark:text-red-400">Erreur de vérification</h1>
                <p className="text-muted-foreground">{message}</p>
                <div className="flex gap-3">
                  <Button onClick={() => navigate('/')} variant="outline" className="flex-1">
                    Accueil
                  </Button>
                  <Button onClick={() => navigate('/profile')} className="flex-1 btn-primary">
                    Mon profil
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
